const state = {
  editorLoader: {
    page: false,
    loading: false,
    downloading: false,
    progress: 0,
    file: null,
    error: false,
  },
};

const getters = {
  editorLoader(state) {
    return state.editorLoader;
  },
};

export default {
  state,
  getters,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/page-loader/vuex.js